export default __webpack_public_path__ + "static/media/sensotrend_signin_check_email.61f367f2.png";